import { render, staticRenderFns } from "./AppUserCard.vue?vue&type=template&id=0445aabc&scoped=true&"
import script from "./AppUserCard.vue?vue&type=script&lang=js&"
export * from "./AppUserCard.vue?vue&type=script&lang=js&"
import style0 from "./AppUserCard.vue?vue&type=style&index=0&id=0445aabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445aabc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0445aabc')) {
      api.createRecord('0445aabc', component.options)
    } else {
      api.reload('0445aabc', component.options)
    }
    module.hot.accept("./AppUserCard.vue?vue&type=template&id=0445aabc&scoped=true&", function () {
      api.rerender('0445aabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppUserCard.vue"
export default component.exports